import { render, staticRenderFns } from "./InStorageOrder.vue?vue&type=template&id=5915c7cf&scoped=true&"
import script from "./InStorageOrder.vue?vue&type=script&lang=js&"
export * from "./InStorageOrder.vue?vue&type=script&lang=js&"
import style0 from "./InStorageOrder.vue?vue&type=style&index=0&id=5915c7cf&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5915c7cf",
  null
  
)

export default component.exports